const Prompt = () => (
  <span>{ '$> ' }</span>
)

export default Prompt



// WEBPACK FOOTER //
// ./src/components/Prompt.js